import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignInAlt, faExclamationTriangle, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [checkingSystem, setCheckingSystem] = useState(true);
  const [isFirstUser, setIsFirstUser] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  const { login, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  
  useEffect(() => {
    // Проверяем, есть ли уже пользователи в системе
    const checkFirstUser = async () => {
      try {
        setCheckingSystem(true);
        const res = await axios.get('/api/auth/check-first-user');
        setIsFirstUser(res.data.isFirstUser);
        
        // Если это первый пользователь, перенаправляем на страницу настройки
        if (res.data.isFirstUser) {
          navigate('/setup-admin');
          return;
        }
        
        setCheckingSystem(false);
      } catch (err) {
        setError('Ошибка при проверке состояния системы');
        setCheckingSystem(false);
      }
    };
    
    checkFirstUser();
  }, [navigate]);
  
  useEffect(() => {
    // Если пользователь уже аутентифицирован, перенаправляем его
    if (isAuthenticated) {
      navigate('/templates');
    }
  }, [isAuthenticated, navigate]);
  
  const { email, password } = formData;
  
  const onChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const onSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    const result = await login(email, password);
    
    if (!result.success) {
      setError(result.message);
    }
    
    setLoading(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  if (checkingSystem) {
    return (
      <div className="text-center my-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Загрузка...</span>
        </div>
        <p className="mt-3">Проверка состояния системы...</p>
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-md-6 offset-md-3 col-lg-4 offset-lg-4">
        <div className="auth-form card shadow">
          <div className="card-body">
            <h2 className="text-center mb-4">Вход в систему</h2>
            
            {error && <div className="alert alert-danger">{error}</div>}
            
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={email}
                  onChange={onChange}
                  required
                />
              </div>
              
              <div className="mb-3">
                <label htmlFor="password" className="form-label">Пароль</label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="password"
                    name="password"
                    value={password}
                    onChange={onChange}
                    required
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={togglePasswordVisibility}
                    title={showPassword ? "Скрыть пароль" : "Показать пароль"}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
              </div>
              
              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={loading}
              >
                {loading ? (
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                ) : (
                  <FontAwesomeIcon icon={faSignInAlt} className="me-2" />
                )}
                Войти
              </button>
            </form>
            
            <div className="mt-3 alert alert-info">
              <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
              Нет аккаунта? Запросите приглашение у администратора системы.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 